export const INQUIRY_REASONS = Object.freeze({
  STALLED: 'Pacco fermo da X giorni', REMINDER: 'Sollecito consegna', NOT_RECEIVED: 'Cliente segnala mancata ricezione',
  UPDATE: 'Richiesta aggiornamento e data prevista di consegna', POD: 'Richiesta prova di consegna', OTHER: 'Altro'
});
export function inquiryEmail({ trackingNumber, orderNumber, reason, days, customText, userName }) {
  const tracking = String(trackingNumber || '').trim() || 'tracking non disponibile';
  const texts = {
    STALLED: `Il pacco risulta fermo da ${days} giorni. Chiediamo un aggiornamento e lo sblocco della spedizione.`,
    REMINDER: 'Sollecitiamo la consegna della spedizione. Vi chiediamo di comunicarci la data prevista.',
    NOT_RECEIVED: 'Il cliente segnala di non aver ancora ricevuto la merce. Chiediamo una verifica e un aggiornamento sulla consegna.',
    UPDATE: 'Chiediamo un aggiornamento sullo stato della spedizione e la data prevista di consegna.',
    POD: 'Chiediamo di inviarci la prova di consegna della spedizione.', OTHER: String(customText || '').trim()
  };
  return { subject: `Sped. ${tracking} - Ordine int. ${orderNumber}`, bodyText: `Buongiorno,\nOrd. int. ${orderNumber}\nSpedizione n. ${tracking}\n\n${texts[reason] || ''}\n\nCordiali Saluti,\n${userName}` };
}
